import { render, staticRenderFns } from "./CustomizeMetalAI.vue?vue&type=template&id=d0cc8302&scoped=true"
import script from "./CustomizeMetalAI.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalAI.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalAI.vue?vue&type=style&index=0&id=d0cc8302&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cc8302",
  null
  
)

export default component.exports